import { render, staticRenderFns } from "./shop-list.vue?vue&type=template&id=562f42bc&scoped=true"
import script from "./shop-list.vue?vue&type=script&lang=js"
export * from "./shop-list.vue?vue&type=script&lang=js"
import style0 from "./shop-list.vue?vue&type=style&index=0&id=562f42bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562f42bc",
  null
  
)

export default component.exports